import getStore from '../store';
import type { AuthUser } from '../store';
import { useEffect, useState } from "react"

export const useAuthUser = () => {

    const [initialized, setInitialized] = useState(getStore().getInitialized());
    const [user, setUser] = useState<AuthUser | null>(getStore().getUser());

    useEffect(() => {

        const store = getStore();

        const onInitialized = () => {
            setInitialized(true);
        }

        const onUserChanged = (user: AuthUser | null) => {
            setUser(user);
        }

        // initial values
        setInitialized(store.getInitialized());
        setUser(store.getUser());

        // listen to changes
        store.on('initialized', onInitialized);
        store.on('userChanged', onUserChanged);

        return () => {
            // cleanup
            store.off('initialized', onInitialized);
            store.off('userChanged', onUserChanged);
        }
    }, []);

    return { initialized, user }
}